import { groupTaskProjects } from '../../lib/operationKanban.js'

export default function ProjectSelectOptions({ projects, prefix = '' }) {
  return groupTaskProjects(projects).map(group => <optgroup key={group.id} label={group.label}>
    {group.projects.map(project => <option key={project.id} value={`${prefix}${project.id}`}>{project.nome}</option>)}
  </optgroup>)
}
